import { Partner, partners } from 'noddi-types';
import { PropsWithChildren, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { createThemeStore, ThemeContext, ThemeStore } from './themeStore';

const applyThemeClasses = (theme: Partner) => {
  const root = document.documentElement;

  // Remove all theme classes first
  Object.values(partners).forEach((className) => {
    if (className) {
      root.classList.remove(className);
    }
  });

  // Add the new theme class if it's not default
  const newThemeClass = partners[theme];
  if (newThemeClass) {
    root.classList.add(newThemeClass);
  }
};

function useGetInitialTheme(): Partner {
  const location = useLocation();
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';

  // Check both pathname and hostname for each partner
  if (location.pathname.includes(partners['bestdrive']) || hostname.includes(partners['bestdrive'])) {
    return 'bestdrive';
  }

  if (location.pathname.includes(partners.tronderdekk) || hostname.includes(partners.tronderdekk)) {
    return 'tronderdekk';
  }

  if (location.pathname.includes(partners.carglass) || hostname.includes(partners.carglass)) {
    return 'carglass';
  }

  return 'default';
}

export function NoddiThemeProvider({ children }: PropsWithChildren<unknown>) {
  const storeRef = useRef<ThemeStore>();

  const initialTheme = useGetInitialTheme();

  useEffect(() => {
    applyThemeClasses(initialTheme);
  }, [initialTheme]);

  if (!storeRef.current) {
    storeRef.current = createThemeStore({
      initialTheme
    });
  }

  return <ThemeContext.Provider value={storeRef.current}>{children}</ThemeContext.Provider>;
}
